import { mergeCustomPrograms } from './../../utils/program-config/customPrograms.js';
import { MARQETA, SUTTON } from './constants.js';
import { isAuth0Flow } from '../../utils/authProvider.js';

export default function programsWithRoles({
  janusPrograms,
  userOrgName,
  redseaPrograms,
  programMetaData,
}) {
  const auth0Flow = isAuth0Flow();

  const hasRedseaPrograms = redseaPrograms && redseaPrograms.length > 0;

  if (auth0Flow) {
    const programsByUser = localStorage.getItem('programsByUser');
    if (programsByUser) {
      try {
        const programs = JSON.parse(programsByUser);
        // If redseaPrograms is available, filter by it; otherwise return all
        if (hasRedseaPrograms) {
          return programs.filter((p) => redseaPrograms.includes(p.short_name));
        }
        return programs;
      } catch (e) {
        // Fall back if parsing fails
      }
    }
    // Fallback: if redseaPrograms is available, use it
    if (hasRedseaPrograms) {
      return redseaPrograms.map((token) => ({
        program: token,
        short_name: token,
      }));
    }
    return [];
  }

  const allProgramsAccess = janusPrograms && calculateAllProgramAccess(janusPrograms);
  const programsList = allProgramsAccess
    ? calculateProgramsList(janusPrograms, programMetaData, userOrgName)
    : janusPrograms;

  const mergedProgramsList = mergeCustomPrograms(programsList);

  const programsWithRoles = calculateProgramsWithRolesList(
    allProgramsAccess,
    mergedProgramsList,
    programMetaData,
    redseaPrograms
  );
  return programsWithRoles;
}

const calculateAllProgramAccess = (programs) =>
  programs.some((program) => program && program.program === 'All');

const calculateProgramsList = (programs, programMetaData, userOrgName) =>
  programMetaData.reduce((acc, org) => {
    if (org.org_name === userOrgName) {
      return org.programs;
    }
    return acc;
  }, []);

const calculateProgramsWithRolesList = (
  allProgramsAccess,
  programsList,
  programMetaData,
  redseaPrograms = []
) => {
  // Users in `marqeta` or `sutton` program in Redsea should see all programs
  // from their respective org in Janus
  const selectAllPrograms = redseaPrograms.includes(MARQETA) || redseaPrograms.includes(SUTTON);

  // Users NOT in `marqeta` or `sutton` program in Redsea should only see programs
  // for which they have a Redsea role
  if (!programsList) {
    return [];
  } else if (selectAllPrograms) {
    return programsList;
  } else {
    return programsList.filter((program) => redseaPrograms.includes(program.short_name));
  }
};
